<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-radio`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.589 2.268a1 1 0 011.366.366l1 1.732a1 1 0 01-.366 1.366L16.339 18h27.9c.972 0 1.761.658 1.761 1.47v25.06c0 .812-.789 1.47-1.762 1.47H3.762C2.789 46 2 45.342 2 44.53V19.47c0-.812.789-1.47 1.762-1.47h4.577l27.25-15.732zM42 22H6v20h36V22zm-26 2a8 8 0 110 16 8 8 0 010-16zm21 10a1 1 0 011 1v2a1 1 0 01-1 1H27a1 1 0 01-1-1v-2a1 1 0 011-1h10zm-21-6a4 4 0 100 8 4 4 0 000-8zm17-2a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1h6z"/></svg>
</template>
<script>

export default {
  name: 'IconRadio',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
